import {maxLength} from "admin-on-rest";

const isImageValid = (values, attributeName, imageName) => {
  return (
    values[attributeName] &&
    values[attributeName][imageName] &&
    Object.keys(values[attributeName][imageName]).length > 0
  );
};

export const validatePromo = (values, {translate}) => {
  const errors = {};

  if (!values.name || values.name.trim() === "") {
    errors.name = translate("resources.promos.validation.requiredPromoName");
  }

  if (!values.valid_from || values.valid_from.trim() === "") {
    errors.valid_from = translate(
      "resources.promos.validation.requiredValidFrom"
    );
  }

  if (!values.industry_ids || values.industry_ids.length === 0) {
    errors.industry_ids = translate(
      "resources.promos.validation.requiredIndustry"
    );
  }

  if (!values.sms_from || values.sms_from.trim() === "") {
    errors.sms_from = translate("resources.welcomeMessage.validation.name");
  }
  if (!values.sms_text || values.sms_text.trim() === "") {
    errors.sms_text = translate("resources.welcomeMessage.validation.smsText");
  }

  if (!isImageValid(values, "images", "large")) {
    errors.images = errors.images || {};
    errors.images.large = translate(
      "resources.promos.validation.requiredImage"
    );
  }

  if (!isImageValid(values, "images", "small")) {
    errors.images = errors.images || {};
    errors.images.small = translate(
      "resources.promos.validation.requiredImage"
    );
  }

  if(values.extra && values.extra.leovegas){
    errors.extra = {};

    if(values.extra.leovegas){
      errors.extra.leovegas = {};

      const lpidNotEmpty = (values.extra.leovegas.lpid !== "" && values.extra.leovegas.lpid !== undefined);
      const bidNotEmpty = (values.extra.leovegas.bid !== "" && values.extra.leovegas.bid !== undefined);

      if(lpidNotEmpty && !bidNotEmpty){
        errors.extra.leovegas.bid = translate(
          "resources.promos.validation.requiredBothIDFields"
        );
      }
      if(!lpidNotEmpty && bidNotEmpty){
        errors.extra.leovegas.lpid = translate(
          "resources.promos.validation.requiredBothIDFields"
        );
      }  
    }
    if(values.extra.mrgreen){
      errors.extra.mrgreen = {};

      const lpidNotEmpty = (values.extra.mrgreen.lpid !== "" && values.extra.mrgreen.lpid !== undefined);
      const bidNotEmpty = (values.extra.mrgreen.bid !== "" && values.extra.mrgreen.bid !== undefined);

      if(lpidNotEmpty && !bidNotEmpty){
        errors.extra.mrgreen.bid = translate(
          "resources.promos.validation.requiredBothIDFields"
        );
      }
      if(!lpidNotEmpty && bidNotEmpty){
        errors.extra.mrgreen.lpid = translate(
          "resources.promos.validation.requiredBothIDFields"
        );
      }  
    }
  }  

  return errors;
};

export const validateStoreName = (value, allValues, props) =>
  (!value || value.trim() === "") &&
  props.translate("resources.virtualSlips.validation.requiredStoreName");

export const validatePartnerName = (value, allValues, props) => {
  return (
    (!value || value.trim() === "") &&
    props.translate("resources.promos.validation.requiredMarketingPartnerName")
  );
};

export const validateIndustry = (value, allValues, props) => {
  return (
    (!value || props.valid.false) &&
    props.translate("resources.promos.validation.requiredIndustry")
  );
};

export const validateVoucherCode = (value, allValues, props) => {
  if((value)){
    let letters = /^[A-Z0-9]+$/;
    
    if(value.match(letters) === null) {
      return props.translate("resources.promos.validation.requiredVoucherCodeUppercase")
    }
  }
  // if(value && value.length !== 10){
  //   return props.translate("resources.promos.validation.requiredVoucherCodeLength");
  // }
};

export const validatePromoIDs = (value, allValues, props) => {
  if((value)){
    let letters = /^[A-Z0-9]+$/;
    
    if(value.match(letters) === null) {
      return props.translate("resources.promos.validation.requiredVoucherCodeUppercase")
    }
  }
  // if(value && value.length !== 10){
  //   return props.translate("resources.promos.validation.requiredVoucherCodeLength");
  // }
};

export const validateMarketingPartnerID = [maxLength(120)];

export const validateCampaignID = [maxLength(120)];


// WEBPACK FOOTER //
// ./src/containers/CRM/Promos/validations.js